import React, { useEffect, useState } from "react";
import Dialog from "@mui/material/Dialog";
import Checkbox from "@mui/material/Checkbox";
import "./TermsAndConditions.scss";
import { useTranslation } from "react-i18next";
import { updateSettingPreference } from "../../services/orgService";
import { toastMessage } from "../../helper";

const TermsAndConditions = (props: any) => {
  const { setShowTermsAndConditionDialog } = props;
  const { t, i18n } = useTranslation();
  const [closeDialog, setCloseDialog] = useState(true);
  const [formData, setFormData] = useState({
    privacyPolicy: false,
    servicePolicy: false,
  });
  const { privacyPolicy, servicePolicy } = formData;
  const companyPreferenceData = JSON.parse(
    localStorage.getItem("companyPreference") || ""
  );

  const validateForm = () => {
    return privacyPolicy && servicePolicy;
  };

  const handleProceed = () => {
    const reqDataTerms = {
      privacyPolicy: formData.privacyPolicy,
      termsAndConditions: formData.servicePolicy,
      financialYear: companyPreferenceData.financialYear,
      id: companyPreferenceData.id,
      isCalendarYear: companyPreferenceData.isCalendarYear,
      // reports: companyPreferenceData.reports,
    };
    updateSettingPreference(reqDataTerms).then(() => {
      setCloseDialog(false);
      setShowTermsAndConditionDialog(false);
      companyPreferenceData.privacyPolicy = true;
      companyPreferenceData.termsAndConditions = true;
      localStorage.setItem(
        "companyPreference",
        JSON.stringify(companyPreferenceData)
      );
    });
  };
  const onChange = (e: any) => {
    if (
      e.target.name === "privacyPolicy" ||
      e.target.name === "servicePolicy"
    ) {
      setFormData((prevData) => ({
        ...prevData,
        [e.target.name]: e.target.checked,
      }));
    } else {
      setFormData((prevData) => ({
        ...prevData,
        [e.target.name]: e.target.value,
      }));
    }
  };
  return (
    <Dialog open={closeDialog} aria-labelledby="form-dialog-title">
      <div className="flex flex-col pw-termsandcondition-dialog gap-5">
        <div className="text-neutral-900 font-bold text-xl">
          To proceed further, please accept the Privacy Policy and Terms &
          Conditions.
        </div>
        <div className="flex flex-row pw-shift-left-10">
          <Checkbox
            value={privacyPolicy}
            name="privacyPolicy"
            onChange={(e) => onChange(e)}
          />
          <div className="text-sm">
            <span>{t("privacyPolicy")}</span>
            <a
              href="https://planetwise.io/privacy-policy"
              target="_blank"
              rel="noreferrer"
              className="pw-primary-color pw-text-underline font-semibold"
            >
              {t("privacyPolicyLink")}
            </a>
          </div>
        </div>
        <div className="flex flex-row pw-shift-left-10">
          <Checkbox
            value={servicePolicy}
            color="primary"
            name="servicePolicy"
            onChange={(e) => onChange(e)}
          />
          <div className="text-sm">
            <span>{t("servicePolicy")}</span>
            <a
              href="https://planetwise.io/terms-conditions"
              target="_blank"
              rel="noreferrer"
              className="pw-primary-color pw-text-underline font-semibold"
            >
              {t("servicePolicyLink")}
            </a>
          </div>
        </div>
      </div>
      <div className="flex flex-row justify-end pw-scope-footer w-full gap-6">
        <div
          className={` pw-scope-button-cancel pw-cursor-pointer text-white ${
            validateForm() ? "pw-primary-button" : "pw-neutral-background"
          }`}
          onClick={() => {
            validateForm() && handleProceed();
          }}
        >
          Proceed
        </div>
      </div>
    </Dialog>
  );
};
export default TermsAndConditions;
